<template>
	<div style="margin: -12px; padding: 12px; border-bottom: 1px solid #e3e3e3;">
    <form @submit.prevent="send">
  		<div class="columns is-mobile">
  			<div class="column">
  				<textarea-autosize class="textarea"
  					placeholder="Tulis pesan..."
            rows="1"
            style="
              border-radius: 30px;
              padding: 7px 15px;
            "
            v-model="text"
            ref="message_text_ref"
          ></textarea-autosize>
  			</div>
  			<div class="column is-narrow">
  				<button type="submit" class="button is-primary is-rounded"><b-icon icon="send"></b-icon></button>
  			</div>
  		</div>
    </form>
	</div>
</template>

<script>
	export default {
    props: {
      sendMessage: {
        type: Function,
        default: () => {}
      }
    },

		data() {
      return {
        text: ''
      }
    },

    methods: {
      send() {
        this.sendMessage(this.text)
        this.text = ''
        this.$refs.message_text_ref.$el.focus()
      }
    }
	}
</script>
